var map = {
	"./personality-relax-btn-beijing.png": "b23a",
	"./personality-relax-btn-bingdao.png": "f9e0",
	"./personality-relax-btn-playing.png": "0016",
	"./personality-relax-btn-riben.png": "ce42",
	"./personality-relax-btn-shenzhen.png": "8fa5",
	"./personality-relax-btn-taiguo.png": "2f9b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "81bd";